import { render, staticRenderFns } from "./FixedInventory.vue?vue&type=template&id=5fb495a8&scoped=true"
import script from "./FixedInventory.vue?vue&type=script&lang=js"
export * from "./FixedInventory.vue?vue&type=script&lang=js"
import style0 from "./FixedInventory.vue?vue&type=style&index=0&id=5fb495a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb495a8",
  null
  
)

export default component.exports